import React from 'react';

import {
  FuelGridContainer,
  FuelGridItem,
  FuelSkeleton,
} from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import SkeletonOriginAndDestination from '../../../../Skeleton/SkeletonOriginAndDestination';
import * as Styled from './SkeletonListAllTabMobileStyles';

function SkeletonListAllTabMobile() {
  return (
    <Styled.WrapperStyledFuelGridContainer>
      <FuelGridContainer gapRow={10}>
        <FuelGridItem sm={3}>
          <Styled.WrapperTruckerInfo>
            <Styled.Wrapper>
              <Styled.Item>
                <FuelSkeleton
                  shape="circle"
                  size="custom"
                  width="40px"
                  height="40px"
                />
              </Styled.Item>
              <Styled.Item>
                <FuelSkeleton
                  shape="pill"
                  size="custom"
                  width="89px"
                  height="16px"
                />
                <FuelSkeleton
                  shape="pill"
                  size="custom"
                  width="59px"
                  height="16px"
                />
              </Styled.Item>
            </Styled.Wrapper>
          </Styled.WrapperTruckerInfo>
        </FuelGridItem>
        <FuelGridItem sm={1}>
          <FuelFlex
            defaultProps={{
              alignItems: 'center',
              gap: 'km4',
              justifyContent: 'flex-end',
            }}
          >
            <FuelSkeleton
              shape="square"
              size="custom"
              width="32px"
              height="32px"
            />
            <FuelSkeleton
              shape="square"
              size="custom"
              width="32px"
              height="32px"
            />
          </FuelFlex>
        </FuelGridItem>
        <FuelGridItem sm={4}>
          <FuelSkeleton
            shape="pill"
            size="custom"
            width="150px"
            height="15px"
          />
        </FuelGridItem>
        <FuelGridItem sm={4}>
          <Styled.WrapperOriginAndDestination>
            <Styled.Wrapper>
              <Styled.Item>
                <SkeletonOriginAndDestination />
              </Styled.Item>
              <Styled.Item>
                <FuelSkeleton
                  shape="pill"
                  size="custom"
                  width="89px"
                  height="16px"
                />
                <FuelSkeleton
                  shape="pill"
                  size="custom"
                  width="135px"
                  height="16px"
                />
              </Styled.Item>
            </Styled.Wrapper>
          </Styled.WrapperOriginAndDestination>
        </FuelGridItem>
        <FuelGridItem sm={4}>
          <FuelSkeleton
            shape="square"
            size="custom"
            width="100%"
            height="40px"
          />
        </FuelGridItem>
      </FuelGridContainer>
    </Styled.WrapperStyledFuelGridContainer>
  );
}

export default SkeletonListAllTabMobile;
